// Zeitstrahl der LP-Schritte: Beim Hover füllen sich die Linien bis zum angesteuerten Schritt
// nacheinander, beim Verlassen leeren sie sich in umgekehrter Reihenfolge. Die Reihenfolge hängt
// vom vorherigen Füllstand ab, deshalb JS statt reinem CSS. Die Dauer pro Linie steht im CSS.
class LpStepsTimeline extends HTMLElement {
  connectedCallback() {
    this.lines = [...this.querySelectorAll('.lp-step__line')];
    this.filledCount = 0;

    this.querySelectorAll('.lp-step').forEach((step, index) => {
      step.addEventListener('pointerenter', () => this.fillTo(index));
    });
    this.addEventListener('pointerleave', () => this.fillTo(0));
  }

  fillTo(targetCount) {
    const previousCount = this.filledCount;

    this.lines.forEach((line, index) => {
      const filling = index >= previousCount && index < targetCount;
      const emptying = index < previousCount && index >= targetCount;
      if (!filling && !emptying) return;

      line.style.setProperty('--lp-line-order', filling ? index - previousCount : previousCount - 1 - index);
      line.toggleAttribute('data-filled', filling);
    });

    this.filledCount = targetCount;
  }
}

if (!customElements.get('lp-steps-timeline')) customElements.define('lp-steps-timeline', LpStepsTimeline);
